export default {
  message: {
    type: 'race',
    data: {
      raceId: 75,
    },
  },
  state: {
    type: 'race',
    time: 1563517053031,
    odds: null,
    outcomes: null,
    delay: 20,
    raceId: 75,
  },
};
